export const config = {
	API_AUTH_HEADER: process.env.API_AUTH_HEADER,
	GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY,
	PACKAGE_VERSION: process.env.PACKAGE_VERSION, // parcel-plugin-package-version puts the package version in an environment variable named PACKAGE_VERSION.
	SENTRY_DSN: process.env.SENTRY_DSN, // Key for using Sentry service.
	API_REQUEST_TIMEOUT: 180000,
}
